<template>
  <div class="home-swip-img-box" v-if="images && images.length > 0">
    <van-swipe :autoplay="3000" indicator-color="white">
      <van-swipe-item v-for="(image, index) in images" :key="index">
        <img :src="image.img" style="height: 180px;width: 100%;" />
      </van-swipe-item>
    </van-swipe>
  </div>
</template>

<script>
export default {
  name: "HomeSwipeImg",
  data() {
    return {
      images: [
        "https://img01.yzcdn.cn/vant/apple-1.jpg",
        "https://img01.yzcdn.cn/vant/apple-2.jpg",
      ],
    };
  },
  created(){
    this.getBanner()
  },
  methods:{
    async getBanner() {
      await this.$http({
        method: "post",
        url: "getBanner",
      }).then((res) => {
        this.images = res.data;
      });
    },
  }
};
</script>

<style>
</style>
